import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import DictionaryService from '../services/dictionary.service';

@Pipe({ name: 'translate', standalone: true, pure: false })
@Injectable({providedIn: 'root'})
export class TranslatePipe implements PipeTransform {
	private dictionaryService: DictionaryService = inject(DictionaryService);
	
	activeLocale: any = undefined;
	
	constructor() {}
	
	transform(path) {
		var session: any = this.getGlobalProperty('session') || {};
		var locale: any = (session.user && session.user.deviceLanguage) || this.dictionaryService.getCurrentLocale();
		if (locale !== this.activeLocale) {
			this.activeLocale = locale;
			this.dictionaryService.setLanguage(locale).catch(() => {});
		}
		return this.dictionaryService.translate(path, locale);
	}
	
	getGlobalProperty(name) {
		var _window: any = window;
		if (name && _window.globalProperties) {
			return _window.globalProperties[name];
		} else {
			return undefined;
		}
	}
	
}
